import type { RootState } from 'store'
import type { FieldName, TradeOfferErrors, TradeOfferValues } from './types'
import validators from './validators'

export const getValue =
  <T extends FieldName>(field: T) =>
  (state: RootState): TradeOfferValues[T] => {
    return state.tradeOffer.values[field]
  }

export const getError =
  <T extends keyof TradeOfferErrors>(field: T) =>
  (state: RootState): TradeOfferErrors[T] | null => {
    return state.tradeOffer.errors[field] ?? null
  }

const hasError = (error: any) => {
  if (error === null) return false

  if (typeof error === 'string') return true

  if (Array.isArray(error)) {
    for (const errorItem of error) {
      if (hasError(errorItem)) return true
    }
  }

  if (typeof error === 'object') {
    for (const errorItem of Object.values(error)) {
      if (hasError(errorItem)) return true
    }
  }

  return false
}

export const getIsFormValid = (state: RootState) => {
  for (const error of Object.values(state.tradeOffer.errors)) {
    if (hasError(error)) return false
  }

  const values = state.tradeOffer.values
  for (const field of Object.keys(values)) {
    const error = validators[field]?.(values)
    if (hasError(error)) return false
  }

  return true
}
